<template>
    <div
        class="input-group-append char-counter"
        v-bind:class="{ danger: size <= 10 }"
    >
        <span class="input-group-text" id="basic-addon2">{{ size }}</span>
    </div>
</template>
<script>
export default {
    name: "char-counter",
    props: {
        size: Number,
    },
};
</script>
